import { ObservableValueProducerBase } from "./ChainableValueProducer";

export class SingleValueProducer<T> extends ObservableValueProducerBase<T> {
    private value: T;

    public constructor(initialValue: T) {
        super();
        this.value = initialValue;
    }

    protected async beginListening(): Promise<void> {
        // Обновление значений передаётся извне
    }

    protected async stopListening(): Promise<void> {
        // Обновление значений передаётся извне
    }

    public async update(value: T): Promise<void> {
        this.value = value;
        await this.emitUpdate(value);
    }

    protected async getCurrentValue(): Promise<T> {
        return this.value;
    }
}
